import { motion } from "framer-motion";
import { Scale, Calculator, Briefcase, Building2, Check } from "lucide-react";

const sections = [
  {
    icon: Scale,
    title: "Asesoría Fiscal",
    subtitle: "Optimización tributaria con criterio",
    points: [
      "IRPF, IVA, Impuesto de Sociedades",
      "Planificación fiscal anual",
      "Modelos trimestrales y anuales",
      "Representación ante inspecciones de Hacienda",
      "Herencias, donaciones y patrimonio",
    ],
  },
  {
    icon: Calculator,
    title: "Asesoría Contable",
    subtitle: "Datos precisos para decisiones acertadas",
    points: [
      "Contabilidad diaria y mensual",
      "Cuentas anuales y libros oficiales",
      "Análisis financiero e informes",
      "Presentación en Registro Mercantil",
      "Cierre contable y previsión de tesorería",
    ],
  },
  {
    icon: Briefcase,
    title: "Asesoría Laboral",
    subtitle: "Todo el ciclo de tu equipo humano",
    points: [
      "Nóminas y seguros sociales",
      "Altas, bajas y contratos",
      "Despidos, finiquitos y conciliaciones",
      "Prevención de riesgos y normativa vigente",
      "Bonificaciones a la contratación",
    ],
  },
  {
    icon: Building2,
    title: "Asesoría Mercantil",
    subtitle: "Acompañamos cada operación societaria",
    points: [
      "Constitución de sociedades",
      "Actas, juntas y modificaciones estatutarias",
      "Operaciones mercantiles y contratos",
      "Fusiones, escisiones y disoluciones",
      "Asesoramiento en compraventa de empresas",
    ],
  },
];

export default function Servicios() {
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-24">
      <div className="max-w-3xl mb-20">
        <div className="text-xs uppercase tracking-[0.32em] text-[#D4AF37] mb-6">
          Servicios
        </div>
        <h1 className="font-serif text-5xl md:text-6xl text-white leading-[1.05] mb-6">
          Todo lo que tu <em className="gold-text not-italic">negocio</em> necesita, bajo un mismo techo.
        </h1>
        <p className="text-lg text-zinc-400 leading-relaxed">
          Cuatro áreas de práctica coordinadas para que no tengas que preocuparte por nada más.
        </p>
      </div>

      <div className="space-y-6">
        {sections.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06 }}
              data-testid={`servicio-${s.title.toLowerCase().replace(/[^a-z]/g, "")}`}
              className="grid md:grid-cols-12 gap-8 bg-[#121214] border border-white/5 rounded-2xl p-8 md:p-12 hover:border-[#D4AF37]/30 transition-colors"
            >
              <div className="md:col-span-5">
                <div className="w-14 h-14 rounded-xl border border-[#D4AF37]/30 grid place-items-center mb-6">
                  <Icon className="w-6 h-6 text-[#D4AF37]" strokeWidth={1.5} />
                </div>
                <h2 className="font-serif text-3xl md:text-4xl text-white mb-3">{s.title}</h2>
                <p className="text-zinc-400 text-lg">{s.subtitle}</p>
              </div>
              <div className="md:col-span-7">
                <ul className="grid sm:grid-cols-2 gap-4">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-zinc-300">
                      <Check className="w-5 h-5 text-[#D4AF37] mt-0.5 flex-shrink-0" strokeWidth={2} />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
